__turbopack_context__.v({
  "Body": "dFPshW_Body",
  "Button": "dFPshW_Button",
  "Button--Next": "dFPshW_Button--Next",
  "Button--Prev": "dFPshW_Button--Prev",
  "ButtonInner": "dFPshW_ButtonInner",
  "ButtonInnerIcon": "dFPshW_ButtonInnerIcon",
  "Dot": "dFPshW_Dot",
  "DotActive": "dFPshW_DotActive",
  "Dots": "dFPshW_Dots",
  "FirstStepButton": "dFPshW_FirstStepButton",
  "FirstStepButton--Next": "dFPshW_FirstStepButton--Next",
  "Footer": "dFPshW_Footer",
  "Media": "dFPshW_Media",
  "MediaEl": "dFPshW_MediaEl",
  "SlideButton": "dFPshW_SlideButton",
  "SlideDescription": "dFPshW_SlideDescription",
  "SlideTitle": "dFPshW_SlideTitle",
  "fadeIn": "dFPshW_fadeIn",
  "skeleton-loading": "dFPshW_skeleton-loading",
});
